// extracted by mini-css-extract-plugin
export var dropdown = "_os-1";
export var hidden = "_os-0";